module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-box"
  }, [_c('h4', {
    staticClass: "header-title m-t-0 m-b-20"
  }, [_vm._v("Administration")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Dans le parc de :")]), _vm._v(" "), _c('user-select', {
    attrs: {
      "id": _vm.customer.user_id
    },
    on: {
      "change": _vm.onUserChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Organisation des fiches :")]), _c('br'), _vm._v(" "), _c('el-tree', {
    attrs: {
      "data": _vm.customersTree,
      "node-key": "id",
      "default-expand-all": "",
      "expand-on-click-node": false,
      "draggable": ""
    },
    on: {
      "node-drag-enter": _vm.handleDragEnter,
      "node-drag-leave": _vm.handleDragLeave,
      "node-drop": _vm.handleDrop
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('div', {
          class: ['custom-tree-node', 'node-customer', 'node-customer-' + data.item.id, data.item.id === _vm.customer.id ? 'node-customer-self' : 'node-customer-other']
        }, [_c('customer', {
          attrs: {
            "item": data.item
          }
        }), _vm._v(" "), _c('customer', {
          attrs: {
            "item": data.item,
            "present": "sources"
          }
        })], 1)
      }
    }])
  }), _vm._v(" "), _c('el-button', {
    staticClass: "m-t-20",
    attrs: {
      "type": "warning",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.searchMerge()
      }
    }
  }, [_vm._v("Rechercher une fusion ...")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c7ef875"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Widgets/Customers/Summary/CustomerAdministrationSummaryWidget.vue
// module id = 679
// module chunks = 1